import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

/**
 * Full-bleed cinematic chapter break — Porsche/Rivian style.
 * Renders an aspect-locked immersive image with a chapter label and optional headline.
 */
export default function ChapterBreak({ src, chapter, title, subtitle, minHeight = '65svh' }) {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1200], [-40, 60]);
  return (
    <section className="relative w-full overflow-hidden bg-black text-white" style={{ minHeight }}>
      <motion.div style={{ y }} className="absolute inset-0">
        <img src={src} alt="" className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-black/60" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 h-full flex items-end pb-16 md:pb-24" style={{ minHeight }}>
        <div>
          {chapter && (
            <div className="flex items-center gap-3 text-[10px] tracking-[0.36em] uppercase text-[#C7A36A]">
              <span>{chapter}</span>
              <span className="w-12 border-t border-[#C7A36A]/60" />
            </div>
          )}
          {title && (
            <h2 className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-4xl">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="mt-6 max-w-md text-white/85 text-[15px] leading-relaxed">{subtitle}</p>
          )}
        </div>
      </div>
    </section>
  );
}
